import Spinner from 'spin.js';
import i18n from './i18n';

let instance = null;

export default class Utils {
  constructor() {
    if (!instance) {
      instance = this;
    }
  }

  getCurrentBrand() {
    return window.EmployeeWeb.ENVConfig.brand;
  }

  setBrowserHistory(history) {
    instance.browserHistory = history;
  }

  getBrowserHistory() {
    return instance.browserHistory;
  }

  setPreviousLocation(loc) {
    instance.previousLocation = loc;
  }

  getPreviousLocation() {
    return typeof instance.previousLocation === 'undefined' ? '' : instance.previousLocation;
  }

  setAppInstantiated(bool) {
    instance.appInstantiated = bool;
  }

  getAppInstantiated() {
    return instance.appInstantiated;
  }

  setInitialLocation(loc) {
    instance.initialLocation = loc;
  }

  fireEvent(el, eventName, data) {
    let ev;

    if (document.createEvent) {
      ev = document.createEvent('HTMLEvents');
      ev.initEvent(eventName, true, false);
      ev = _.extend(ev, data);
      el.dispatchEvent(ev, data);
    } else if (document.createEventObject) {
      ev = document.createEventObject();
      ev = _.extend(ev, data);
      el.fireEvent(eventName, ev, data);
    }
  }

  getInitialLocation() {
    return instance.initialLocation;
  }

  setUpSpinner() {
    let spinColor = '#37C2DE';
    if (window.EmployeeWeb.ENVConfig.brand == 'cerner') {
      spinColor = '#0D94D2';
    }
    instance._spinnerOpts = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      color: spinColor,
    };
    instance._spinner = new Spinner(instance._spinnerOpts).spin();
  }

  setAuthToken(token) {
    instance.setCookie('authToken', token);

    instance.setMakeshiftTokenHeader();
    instance.setUpSpinner();
  }

  getAuthToken() {
    return instance.getCookie('authToken');
  }

  setMakeshiftTokenHeader() {
    const that = instance;
    $.ajaxSetup({
      beforeSend(xhr, options) {
        xhr.setRequestHeader('Authorization', `Token ${that.getAuthToken()}`);
        return true;
      },
    });
  }

  setCoreUser(obj) {
    obj.domain = window.location.hostname;
    obj.brand = window.EmployeeWeb.ENVConfig.brand;
    localStorage.setItem('coreUser', JSON.stringify(obj));
  }

  getCoreUser() {
    return JSON.parse(localStorage.getItem('coreUser'));
  }

  setLastUserFetch() {
    localStorage.setItem('lastUserFetch', Date.now());
  }

  getLastUserFetch() {
    return localStorage.getItem('lastUserFetch');
  }

  checkFetchedUser() {
    const lastUserFetch = this.getLastUserFetch();
    if (lastUserFetch) {
      const diff = Date.now() - lastUserFetch;
      if (parseInt(diff, 10) > 86400000) {
        instance.setLastUserFetch();
        window.location.reload();
      }
    } else {
      instance.setLastUserFetch();
      window.location.reload();
    }
  }

  checkUserAuth() {
    const token = instance.getAuthToken();
    if (token !== null) {
      instance.setAuthToken(token);
      let location = window.location.pathname;
      if (instance.getPreviousLocation() != '') {
        location = instance.getPreviousLocation();
      }
      instance.getBrowserHistory().push(location);
    } else {
      instance.setPreviousLocation(window.location.pathname);
      instance.getBrowserHistory().push('/');
    }
  }

  setLocale(locale) {
    instance.setCookie('locale', locale);
    locale = locale.replace('_ca', '');
    if (i18n.language !== locale || moment.locale() !== locale) {
      i18n.changeLanguage(locale);
      moment.locale(locale);
    }
  }

  getLocale() {
    return instance.getCookie('locale') || 'en';
  }

  isNotDefined(obj) {
    return typeof obj === 'undefined' || obj === null || obj == '';
  }

  formatLocaleDate(momentObj) {
    let localeDate;
    const locale = instance.getLocale();
    if (['en', 'en_ca'].includes(locale)) {
      localeDate = momentObj.format('ddd MMM D, YYYY');
    } else if ('fr' == locale) {
      localeDate = momentObj.format('ddd D MMM YYYY').replace(/\./g, '');
    } else if ('es' == locale) {
      localeDate = momentObj.format('ddd, D MMM YYYY').replace(/\./g, '');
    }
    return localeDate;
  }

  formatTimeString(time) {
    time = time.replace(' am', 'a');
    time = time.replace(' pm', 'p');
    time = time.replace(':00', '');
    return time;
  }

  companyTimezoneOffset(date) {
    const dateCopy = date.clone();
    // dateCopy.tz(instance.getCoreUser().inferred_time_zone);
    const dateOffset = date.utcOffset();
    const dateCopyOffset = dateCopy.utcOffset();
    dateCopy.add(dateOffset - dateCopyOffset, 'minutes');

    return dateCopy;
  }

  fadeOutElements(elements) {
    [].forEach.call(elements, (el) => {
      el.classList.add('remove');
    });
  }

  getGlobalCoords(elem) {
    const box = elem.getBoundingClientRect();
    const { body } = document;
    const docEl = document.documentElement;
    const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    const scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
    const clientTop = docEl.clientTop || body.clientTop || 0;
    const clientLeft = docEl.clientLeft || body.clientLeft || 0;

    // calculate global coordinates, package up, and return to sender.
    const top = box.top + scrollTop - clientTop;
    const left = box.left + scrollLeft - clientLeft;
    const { width } = box;
    const { height } = box;

    return {
      top: Math.round(top),
      left: Math.round(left),
      width: Math.round(width),
      height: Math.round(height),
    };
  }

  resizeContainer(newHeight) {
    const padBuffer = 30;
    const minHeight = $('.month').height() + $('#calendar-header').height();
    if (newHeight + padBuffer > instance.lastContaierHeight) {
      if (newHeight + padBuffer > minHeight) {
        instance.lastContaierHeight = newHeight + padBuffer;
        $('section#schedule #schedule-content-container').height(newHeight + padBuffer);
      } else {
        instance.lastContaierHeight = minHeight + padBuffer;
        $('section#schedule #schedule-content-container').height(minHeight + padBuffer);
      }
    }
  }

  signOut() {
    AccountStore.trigger('account:logout');
    instance.deleteCookie('authToken');
    localStorage.removeItem('coreUser');
    instance.setPreviousLocation('');
    $.ajaxSetup({
      beforeSend(xhr, options) {},
      error(xhr) {},
    });
    instance.getBrowserHistory().push('/');
    instance.removeSpinner();
    instance.setLocale('en');
    // Disabling BambooSSO logout redirect functionality.
    // instance.signOutThirdParty(user);
  }

  signOutThirdParty(user) {
    const is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const is_explorer = typeof document !== 'undefined' && !!document.documentMode;

    if (is_safari || is_explorer) {
      if (user.account_provider == 'bamboo' && user.auth_method == 'sso' && user.auth_subdomain) {
        window.location.href = `https://${user.auth_subdomain}.bamboohr.com/login.php?logout=1`;
      }
    }
  }

  replaceElementWithSpinner(el) {
    if (!_.isUndefined(el) && instance.doesSpinnerExist()) {
      el.appendChild(instance._spinner.el);
    }
  }

  doesSpinnerExist() {
    return !_.isUndefined(instance._spinner);
  }

  removeSpinner() {
    if (!instance._spinner) return
    if (instance._spinner.el != null && instance._spinner.el.parentNode != null) {
      instance._spinner.el.parentNode.removeChild(instance._spinner.el);
    }
  }

  enableGlobalSpinner() {
    instance.replaceElementWithSpinner(document.querySelector('#contentContainer'));
  }

  getEndpointParam(key) {
    return appConstants.EndPointParameterKeys[key];
  }

  setCurrentDate(date) {
    instance.currentDate = date;
  }

  getCurrentDate() {
    return instance.currentDate;
  }

  validateEmail(email) {
    const emailRegEx = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailRegEx.test(email);
  }

  validatePhone(phone) {
    const phoneRegEx = /1?\W*([1-9][0-9][0-9])\W*([1-9][0-9]{2})\W*([0-9]{4})(\se?x?t?(\d*))?/;
    return phoneRegEx.test(phone);
  }

  setCookie(key, value, exdays = 1) {
    const date = new Date();
    date.setTime(date.getTime() + exdays * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${key}=${value};${expires};path=/`;
  }

  getCookie(key) {
    const name = `${key}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookies = decodedCookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      let obj = cookies[i];
      while (obj.charAt(0) == ' ') {
        obj = obj.substring(1);
      }
      if (obj.indexOf(name) == 0) {
        const val = obj.substring(name.length, obj.length);
        if (val === '') return null;
        return val;
      }
    }
    return null;
  }

  deleteCookie(key) {
    const expires = 'expires=Thu, 01 Jan 1970 00:00:00 UTC';
    document.cookie = `${key}=;${expires};path=/`;
  }

  getFirstActiveExchange(exchanges, allowAccepted) {
    let rtnExchange = null;
    if (_.isUndefined(exchanges)) {
      return rtnExchange;
    }
    const len = exchanges.length;
    for (let i = 0; i < len; i++) {
      if (
        exchanges[i].state == 'new'
        || (allowAccepted && (exchanges[i].state == 'new' || exchanges[i].state == 'accepted'))
      ) {
        rtnExchange = exchanges[i];
        break;
      }
    }
    return rtnExchange;
  }

  isDateBetweenOrSame(compareDate, startDate, endDate) {
    if (
      instance.isNotDefined(compareDate)
      || instance.isNotDefined(startDate)
      || instance.isNotDefined(endDate)
    ) { return false; }

    return compareDate.isBetween(startDate, endDate, 'day', '[]');
  }

  initializeTabs() {
    $('.tabs li a').click(function (e) {
      $('.tabs li a').removeClass('selected');
      $(this).addClass('selected');

      const pane = $(this).attr('data-target');
      $('.tab-panes .tab-pane').each(function () {
        $(this).removeClass('active');
      });
      $(`.tab-panes .tab-pane.${pane}`).addClass('active');

      const posX = $(this).offset().left;
      let posY = $(this).offset().top;
      $('.selected span').css({
        left: (e.pageX - posX) - 25,
        top: (e.pageY - posY) - 25,
      });
    });
  }

  formatUnformattedBreaks(breaks_in_minutes) {
    return _.chain(breaks_in_minutes.join().split(','))
      .reduce((hash, duration) => {
        hash[duration] = (hash[duration] || 0) + 1;
        return hash;
      }, {})
      .map((count, duration) => {
        let breakString = `${duration / 60} ${i18n.t('Utils.minutes')}`;
        if (count > 1) breakString += ` (${count})`;
        return breakString;
      })
      .value()
      .join(', ');
  }
}
